import React from 'react';
/* --- import Components ----*/
import { GoogleReviews } from '../GoogleReview';
import ButtonScrollToForm from './ButtonScrollToForm';
import { Section } from '../Section';
import { SectionTitle } from '../Typography';
/* --- import Styles and Images ----*/
import Star from '../Icons/Star';
import colors from 'src/style/colors';

const TestimonialsSectionLandingPage = ({ fromPage, hideButton }) => {
  return (
    <Section theme="secondary" landing>
      <SectionTitle isMobileCenter isCenter css={{ marginBottom: 30, width: '100%' }}>
        Témoignages de <span css={{ color: colors.purple }}>diplômés</span>
      </SectionTitle>
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Star />
        <Star />
        <Star />
        <Star />
        <Star />
      </div>
      <GoogleReviews course="landingPage" />
      {!hideButton && (
        <ButtonScrollToForm
          text={
            fromPage === 'reunion'
              ? `Je visionne la réunion d'information\u00A0!`
              : fromPage === 'brochure'
                ? `Recevoir les brochures 📩`
                : `Je postule\u00A0!`
          }
        />
      )}
    </Section>
  );
};

export default TestimonialsSectionLandingPage;
